var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOverall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#D1FAE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.625 12.8335C20.9922 12.8335 19.6016 13.8765 19.0898 15.3335H17.625C16.2461 15.3335 15.125 16.4546 15.125 17.8335V30.3335C15.125 31.7124 16.2461 32.8335 17.625 32.8335H27.625C29.0039 32.8335 30.125 31.7124 30.125 30.3335V17.8335C30.125 16.4546 29.0039 15.3335 27.625 15.3335H26.1602C25.6484 13.8765 24.2578 12.8335 22.625 12.8335ZM22.625 15.3335C23.3149 15.3335 23.875 15.8936 23.875 16.5835C23.875 17.2734 23.3149 17.8335 22.625 17.8335C21.9351 17.8335 21.375 17.2734 21.375 16.5835C21.375 15.8936 21.9351 15.3335 22.625 15.3335ZM27.0391 23.4976L22.0391 28.4976C21.6719 28.8647 21.0781 28.8647 20.7148 28.4976L18.2109 25.9976C17.8438 25.6304 17.8438 25.0366 18.2109 24.6733Cnan nan 19.1719 24.3062 19.5352 24.6733L21.3711 26.5093L25.7109 22.1694C26.0781 21.8022 26.6719 21.8022 27.0352 22.1694Cnan nan 27.4023 23.1304 27.0352 23.4937L27.0391 23.4976Z",
    fill: "#10B981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOverall);
export default __webpack_public_path__ + "static/media/ic_overall.126a358595054972fa1b5f91e5034b9f.svg";
export { ForwardRef as ReactComponent };